import {
  type GetReleaseNotesResponse,
  type GetCycledEnergyResponse,
  type GetCycledEnergyMeasurementsResponse,
  type GetCycledEnergyMeasurementsSearchParameters,
  type GetChargingPowerChartsResponse,
  type GetChargingPowerChartsSearchParameters,
} from './types/battery-monitoring-api';
import { siteConfig } from '@/app/config/global';
import { createPathQueryString } from '@/utils/http-client/url-helpers';
import createHttpClient from '@/utils/http-client/create-http-client';

interface BatteryMonitoringApi {
  getReleaseNotes: () => Promise<GetReleaseNotesResponse>;
  getVehicles: () => Promise<GetCycledEnergyResponse>;
  getCycledEnergyMeasurements: (
    searchParameters: GetCycledEnergyMeasurementsSearchParameters,
  ) => Promise<GetCycledEnergyMeasurementsResponse>;
  getChargingPowerCharts: (
    searchParameters: GetChargingPowerChartsSearchParameters,
  ) => Promise<GetChargingPowerChartsResponse>;
}

const httpClient = createHttpClient(siteConfig.batteryMonitoringApi);

export const batteryMonitoringApi: BatteryMonitoringApi = {
  getReleaseNotes: async () => {
    const pathParameters = ['api', 'v1', 'release-notes'];
    const response = await httpClient.get<GetReleaseNotesResponse>(
      createPathQueryString({
        path: pathParameters,
      }),
    );
    return response.data;
  },
  getVehicles: async () => {
    const pathParameters = ['api', 'v1', 'cycled-energy'];
    const response = await httpClient.get<GetCycledEnergyResponse>(
      createPathQueryString({
        path: pathParameters,
      }),
    );
    return response.data;
  },
  getCycledEnergyMeasurements: async (searchParameters: GetCycledEnergyMeasurementsSearchParameters) => {
    const pathParameters = ['api', 'v1', 'cycled-energy', 'measurements', searchParameters.chassisNumber];
    const response = await httpClient.get<GetCycledEnergyMeasurementsResponse>(
      createPathQueryString({
        path: pathParameters,
      }),
    );
    return response.data;
  },
  getChargingPowerCharts: async (searchParameters: GetChargingPowerChartsSearchParameters) => {
    const pathParameters = ['api', 'v1', 'cycled-energy', 'charging-power', searchParameters.chassisNumber];
    const response = await httpClient.get<GetChargingPowerChartsResponse>(
      createPathQueryString({
        path: pathParameters,
      }),
    );
    return response.data;
  },
};
